import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/packages")({
  beforeLoad: () => redirect({to: "/plans", replace: true}),
});
